import LKEventImg from "../../assets/images/LK_Icons/LK_Event.svg";
import LKWhiteEventImg from "../../assets/images/LK_Icons/LK_White_Event.svg";
import LKLocationImg from "../../assets/images/LK_Icons/LK_Location Pin.svg";
import LKWhiteLocationImg from "../../assets/images/LK_Icons/LK_White_Location Pin.svg";
import LKExcelImg from "../../assets/images/LK_Icons/LK_File.svg";
import LKPDFImg from "../../assets/images/LK_Icons/LK_Ex PDF.png";


export const locationData = [{ name: "Bengaluru" }, { name: "Mysuru" }, { name: "Mumbai" }, { name: "Hyderabad" }, { name: "Delhi" }, { name: "Chennai" }];
export const projectData = [
  { value: "project1", name: "Project 1" },
  { value: "project2", name: "Project 2" },
  { value: "project3", name: "Project 3" },
];
export const dashboardData = [
  {
    name: "Calendar",
    value: "calendar",
    // icon: "ri-calendar-line",
    image: LKEventImg,
    hoverImage: LKWhiteEventImg,
  },
  {
    name: "Location",
    value: "location",
    // icon: "ri-map-pin-2-line",
    image: LKLocationImg,
    hoverImage: LKWhiteLocationImg,
  },
  {
    name: "Clear",
    value: "clear",
    icon: "ri-filter-off-line",
  },
  // {
  //   name: "Projects",
  //   value:"pojects",
  //   icon: "ri-folder-line",
  // },
];
export const reportData = [
  {
    name: "Revenue Report",
    value: "revenueReport",
    icon: "ri-download-fill",
  },
  {
    name: "Revenue vs Expense",
    value: "revenueVexpense",
    icon: "ri-download-fill",
  },
  {
    name: "Energy Report",
    value: "EnergyReport",
    icon: "ri-download-fill",
  },
  {
    name: "Capacity Utilization Report",
    value: "capacityUtilization",
    icon: "ri-download-fill",
  },
  {
    name: "Payment and Transaction Report",
    value: "transaction",
    icon: "ri-download-fill",
  },
  {
    name: "All Reports",
    value: "allReport",
    icon: "ri-download-fill",
  },
];
export const dateRangeData = [
  {
    name: "Today",
    value: "today",
  },
  {
    name: "Yesterday",
    value: "yesterday",
  },
  {
    name: "Last 7 Days",
    value: "day7",
  },
  {
    name: "Last 30 Days",
    value: "day30",
  },
  {
    name: "This Month",
    value: "thisMonth",
  },
  {
    name: "Last Month",
    value: "lastMonth",
  },
  {
    name: "Custom Date Range",
    value: "dateRange",
    icon: "ri-add-line",
  },
];

export const downloadData = [
  {
    name: "PDF",
    value: "pdf",
    image: LKPDFImg,
    hoverImage: LKPDFImg,
  },
  {
    name: "Excel",
    value: "excel",
    image: LKExcelImg,
    hoverImage: LKExcelImg,
  },
 
];